/**
 * 기안서·근태계 작성/보기 화면의 모바일 한 줄 배치
 * 화면 폭 767px 이하에서는 양식 설정(DnD)의 3열 격자 대신, 배치된 항목을 위→아래·왼→오른쪽 순서로 한 줄에 하나씩 놓는다.
 * (인쇄본·양식 설정 화면은 기존 격자 배치 유지)
 */

const STACKED_FORM_MEDIA_QUERY = '(max-width: 767px)';

/**
 * 화면을 열 때 한 번만 판단한다.
 * 창 크기·화면 회전에 따라 배치를 바꾸면 항목이 다시 마운트되면서 각 항목이 data(서버 값)로 userInput을 다시 채워
 * 작성 중이던 입력이 사라지므로, 열려 있는 동안에는 배치를 바꾸지 않는다.
 */
export const getIsStackedFormLayout = () => typeof window !== 'undefined' && window.matchMedia(STACKED_FORM_MEDIA_QUERY).matches;

// 한 줄 배치에서 내용 높이만큼만 차지하는 항목(입력·글자·로고). 나머지(결재란·근태 구분·기간·신청자 문구·글상자·에디터)는 양식에서 지정한 높이 유지
// (신청자 문구(10)는 서명 이미지가 위로 겹쳐 그려지므로(absolute) 지정 높이를 유지해야 다음 항목을 덮지 않음)
const STACKED_AUTO_HEIGHT_SUB_CDS = ['2', '3', '4', '5', '12', '13', '14', '15', '16', '17', '19', '20', '22', '23'];
export const isStackedAutoHeight = (subCd: string) => STACKED_AUTO_HEIGHT_SUB_CDS.includes(subCd);

/**
 * 격자 배치와 같은 기준(행 → 열 순서, 한 칸에 하나)으로 배치된 항목을 한 줄 배치 순서로 반환
 */
export const getStackedCells = <T extends { aRow: number | null; aCol: number | null }>(cells: T[], rowCount: number, colCount: number): T[] => {
  const result: T[] = [];
  for (let row = 0; row < rowCount; row += 1) {
    for (let col = 0; col < colCount; col += 1) {
      const cell = cells.find((c) => c.aRow === row && c.aCol === col);
      if (cell) result.push(cell);
    }
  }
  return result;
};
